import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IJourneyOverviewData } from './../../interfaces/journey.interface';
import { JourneyService } from './../../services/journey.service';

@Component({
	selector: 'journey-overview',
	templateUrl: './journey-overview.component.html',
	styleUrls: ['./journey-overview.component.scss'],
})
export class JourneyOverviewComponent implements OnInit {
	@Input() customerId: string;
	@Input() firstName;
	@Output() goTo = new EventEmitter();

	isExpanded = false;
	showOverview = false;
	data: IJourneyOverviewData = null;
	constructor(private journeyService: JourneyService) {}

	ngOnInit(): void {
		this.getOverview();
	}

	getOverview() {
		this.journeyService
			.getOverview(this.customerId)
			.toPromise()
			.then((res) => {
				this.data = {
					...res,
					board: {
						...res.board,
						percentage: Math.round(res.board.percentage),
					},
				} as IJourneyOverviewData;
				this.showOverview = true;
			})
			.catch(() => {
				this.showOverview = false;
			});
	}

	public getColor(progress: number) {
		if (progress > 75) {
			return 'green';
		} else if (progress > 25) {
			return 'blue';
		} else if (progress > 0) {
			return 'yellow';
		}
		return 'white';
	}
}
